export default {
  send (type, message) {
    console.log('Posting ' + type + ': ' + JSON.stringify(message))
    window.parent.postMessage({
      system: 'tavleboka',
      type,
      data: message
    }, '*')
  },
  receive (message) {
    return message.data
  }
}
